import "./assets/main.css";

import "mapbox-gl/dist/mapbox-gl.css";

import { createApp } from "vue";

import ui from "@nuxt/ui/vue-plugin";
import * as Sentry from "@sentry/vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import { createPinia } from "pinia";

import { startBuildRefreshCheck } from "@ca/frontend-utils/build-refresh";

import App from "./App.vue";
import router from "./router";

const app = createApp(App);

Sentry.init({
	app,
	dsn: "https://16f3c592cb1759895cf9c2255eecd35d@o4509397300674560.ingest.us.sentry.io/4509397302181888",
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true,
	enabled: !!import.meta.env.PROD, 
	integrations: [
		// send console.log, console.warn, and console.error calls as logs to Sentry
		Sentry.consoleLoggingIntegration({ levels: ["log", "info", "warn", "error"] }),
	],
	enableLogs: true,
});

app.use(createPinia());
app.use(router);
app.use(ui);
app.use(VueQueryPlugin);
app.mount("#app");

// Start after mount so the Nuxt UI toast infrastructure is ready for the stale-build prompt.
startBuildRefreshCheck(app, "web");
